import React from 'react';
import ContainerTemplate from '../../../components/template/Container';
import ClasesView from './ClasesView';
import * as ROUTES from '../../../router/Routes';

const module = () => {
  return (
    <ContainerTemplate active={ROUTES.clases} routes={[]}>
      <ClasesView />
    </ContainerTemplate>
  );
};

export default module;
